export const objectUtils = {
  methods: {
    isEmpty (obj) {
      return (Object.entries(obj).length === 0 && obj.constructor === Object)
    },
    toBase64 (file) {
      return new Promise((resolve, reject) => {
        let fileReader = new FileReader()

        fileReader.readAsDataURL(file)

        fileReader.onload = () => resolve(fileReader.result)
        fileReader.onerror = error => reject(error)
      })
    }
  }
}
